import React from 'react';
import UIModelTable from '../../components/UIModelTable/UIModelTable';
import { TParty } from '../../../../../../types/Context/AppContext';

type ModelListProps = {
  id?: string;
  projectId: string;
  userProjectDataModels: any;
  selectedParty: TParty;
  refreshRef?: React.MutableRefObject<(() => void) | null>;
  onFreestyleUIModelChange?: (hasFreestyle: boolean) => void;
};

export const ModelList = ({
  id,
  projectId,
  userProjectDataModels,
  selectedParty,
  refreshRef,
  onFreestyleUIModelChange,
}: ModelListProps) => {
  return (
    <div className="tw-w-full">
      <UIModelTable
        projectId={projectId}
        selectedParty={selectedParty}
        refreshRef={refreshRef}
        industryId={userProjectDataModels.industry}
        onFreestyleUIModelChange={onFreestyleUIModelChange}
      />
    </div>
  );
};

export default ModelList;
